import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import XtramModal, { XtramButton, XtramCheckbox, xtramStyles } from '../Widgets/XtramModal/XtramModal';
import styles from './BankXtram.module.scss';
import '../../pages/BankMatching/BankMatching.css';

const ImportDialog = ({
    open,
    onClose,
    onImport,
    onPreview,
    showXtramTemplateOption = false,
    showIsracardTemplateOption = false,
}) => {
    const { t, i18n } = useTranslation();
    const [userFile, setUserFile] = useState(null);
    const [useXtramTemplate, setUseXtramTemplate] = useState(false);
    const [useIsracardTemplate, setUseIsracardTemplate] = useState(false);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: (acceptedFiles) => setUserFile(acceptedFiles[0]),
    });

    const handleClose = () => {
        setUserFile(null);
        setUseXtramTemplate(false);
        setUseIsracardTemplate(false);
        onClose();
    };

    const handleImport = () => {
        if (!userFile) return;
        if (onPreview) {
            onPreview(userFile, useXtramTemplate, useIsracardTemplate);
        } else {
            onImport(userFile, useXtramTemplate, useIsracardTemplate);
        }
        handleClose();
    };

    return (
        <XtramModal
            open={open}
            onClose={handleClose}
            title={t('ImportFile')}
            direction={i18n.dir()}
            footer={
                <>
                    <XtramButton variant="secondary" onClick={handleClose}>{t('Cancel')}</XtramButton>
                    <XtramButton onClick={handleImport} disabled={!userFile}>{t('Import')}</XtramButton>
                </>
            }
        >
            <div {...getRootProps()} className={`${styles.dropzone} ${isDragActive ? styles.dropzoneActive : ''}`}>
                <input {...getInputProps()} />
                {userFile ? (
                    <>
                        <InsertDriveFileIcon className={styles.dropzoneIcon} />
                        <p className={styles.dropzoneText}>{userFile.name}</p>
                    </>
                ) : (
                    <>
                        <CloudUploadIcon className={`${styles.dropzoneIcon} animated-upload-icon`} />
                        <p className={styles.dropzoneText}>
                            {isDragActive ? t('DropFilesHere') : t('DragDropFilesOrClick')}
                        </p>
                    </>
                )}
            </div>

            {userFile && (
                <div className={styles.fileRow}>
                    <span className={xtramStyles.muted}>{userFile.name}</span>
                    <XtramButton variant="ghost" small onClick={() => setUserFile(null)}>{t('Clear')}</XtramButton>
                </div>
            )}

            {(showXtramTemplateOption || showIsracardTemplateOption) && (
                <div className={styles.options}>
                    {showXtramTemplateOption && (
                        <XtramCheckbox
                            checked={useXtramTemplate}
                            label={t('UseXtramTemplate')}
                            onChange={(checked) => {
                                setUseXtramTemplate(checked);
                                if (checked) setUseIsracardTemplate(false);
                            }}
                        />
                    )}
                    {showIsracardTemplateOption && (
                        <XtramCheckbox
                            checked={useIsracardTemplate}
                            label={t('UseIsracardTemplate')}
                            onChange={(checked) => {
                                setUseIsracardTemplate(checked);
                                if (checked) setUseXtramTemplate(false);
                            }}
                        />
                    )}
                </div>
            )}
        </XtramModal>
    );
};

export default ImportDialog;
